<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="mcd-card-header">
    <mat-card-title class="mcd-card-title" *ngIf="!isEditMode">Add Local Equipment Standard</mat-card-title>
    <mat-card-title class="mcd-card-title" *ngIf="isEditMode">Update Local Equipment Standard</mat-card-title>
  </mat-card-header>
  <div class="mat-card-wrapper" style="background-color: #f3f3f3">
    <mat-card-content class="mcd-card-content" style="background-color: #f3f3f3">
      <form [formGroup]="addEquipmentStandardForm">
        <div class="mcd-edit-form mcd-grbes-form">
          <div style="margin: auto">
            <div style="
                padding: 10px;
                background-color: #ffffff;
                border: 1px solid #a0a0a04d;
                border-radius: 8px;
              ">
              <div style="margin-bottom: 50px">
                <div class="eqipmentClass">
                  <app-stepper [steps]="formSteps"></app-stepper>
                </div>
                <div class="col-12" style="margin: auto">
                  <mat-stepper linear labelPosition="bottom" #stepper (selectionChange)="onStepChange($event)"
                    style="margin-bottom: 10px">
                    <mat-step [stepControl]="step0Group">
                      <ng-template matStepLabel>Category and Location</ng-template>
                      <div class="col-9" style="margin: auto">
                        <div>
                          <div>
                            <label for="operationsCategory" style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Title*
                              <span matTooltip="Info about the action" style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <div class="title">
                              <input [ngStyle]="{
                                  'margin-bottom':
                                    addEquipmentStandardForm.get('title')
                                      ?.touched &&
                                    addEquipmentStandardForm
                                      .get('title')
                                      ?.hasError('required')
                                      ? '0px'
                                      : '30px',
                                }" name="title" formControlName="title" required placeholder="Enter Title"
                                (paste)="onPasteCleanup('title')" class="form-title" />
                              <mat-error *ngIf="
                                  addEquipmentStandardForm.get('title')
                                    .touched &&
                                  addEquipmentStandardForm
                                    .get('title')
                                    .hasError('required')
                                ">
                                Title is required
                              </mat-error>
                            </div>
                          </div>
                        </div>

                        <div [ngStyle]="{
                            'margin-bottom':
                              addEquipmentStandardForm.get('equipmentTypeId')
                                ?.touched &&
                              addEquipmentStandardForm
                                .get('equipmentTypeId')
                                ?.hasError('required')
                                ? '45px'
                                : '75px',
                          }">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Equipment Type*
                            <span matTooltip="Info about the action" style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span>
                          </label>
                          <div class="category-dropdown-wrapper">
                            <ng-multiselect-dropdown [ngClass]="{
                                'invalid-border':
                                  step0Group.get('equipmentTypeId')?.invalid &&
                                  step0Group.get('equipmentTypeId')?.touched,
                              }" class="dropdown-list" [placeholder]="" [settings]="equipmentdropdownSettings"
                              [data]="equipMentDropdownList" [(ngModel)]="selectedEquipmentType"
                              (onSelect)="onEquipmentSelect($event)"
                              (onDeSelect)="onEquipmentDeSelect($event)"
                              [ngModelOptions]="{ standalone: true }">
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
                        <div style="font-size: x-small; margin-bottom: 20px">
                          <mat-error *ngIf="
                              addEquipmentStandardForm.get('equipmentTypeId')
                                .touched &&
                              addEquipmentStandardForm
                                .get('equipmentTypeId')
                                .hasError('required')
                            ">
                            Equipment Type is required
                          </mat-error>
                        </div>

                        <div [ngStyle]="{
                            'margin-bottom':
                              addEquipmentStandardForm.get('supplierId')
                                ?.touched &&
                              addEquipmentStandardForm
                                .get('supplierId')
                                ?.hasError('required')
                                ? '45px'
                                : '75px',
                          }">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Supplier*
                            <span matTooltip="Info about the action" style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span>
                          </label>
                          <div class="category-dropdown-wrapper">
                            <ng-multiselect-dropdown [ngClass]="{
                                'invalid-border':
                                  step0Group.get('supplierId')?.invalid &&
                                  step0Group.get('supplierId')?.touched,
                              }" class="dropdown-list" [placeholder]="" [settings]="equipmentdropdownSettings"
                              [data]="supplierDropdownList" [(ngModel)]="selectedSupplier"
                              (onSelect)="onSupplierSelect($event)"
                              (onDeSelect)="onSupplierDeSelect($event)"
                              [ngModelOptions]="{ standalone: true }">
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
                        <div style="font-size: x-small; margin-bottom: 20px">
                          <mat-error *ngIf="
                              addEquipmentStandardForm.get('supplierId')
                                .touched &&
                              addEquipmentStandardForm
                                .get('supplierId')
                                .hasError('required')
                            ">
                            supplier is required
                          </mat-error>
                        </div>

                        <div style="margin-bottom: 30px">
                          <div>
                            <label for="operationsCategory" style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Model*
                              <span matTooltip="Info about the action" style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <div class="title">
                              <input name="title" formControlName="model" required placeholder="Enter model"
                                (paste)="onPasteCleanup('title')" class="form-title" />
                              <mat-error *ngIf="
                                  addEquipmentStandardForm.get('model')
                                    .touched &&
                                  addEquipmentStandardForm
                                    .get('model')
                                    .hasError('required')
                                ">
                                Model is required
                              </mat-error>
                            </div>
                          </div>
                        </div>

                        <div style="margin-top: 40px">
                          <!-- <button
                          matButton
                          matStepperPrevious
                          (click)="previousStep()"
                          style="
                           width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;

                              background-color: #ffffff;
                          "
                        >
                          <img
                            src="/assets/images/leftarrow.svg"
                            alt="arrow"
                            style="margin-right: 5px"
                          />Back
                        </button> -->
                          <button (click)="nextStep()" matButton matStepperNext style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;

                              background-color: #ffffff;
                            ">
                            Next<img src="/assets/images/rightarrow.svg" alt="arrow" style="margin-left: 5px" />
                          </button>
                        </div>
                      </div>
                    </mat-step>

                    <mat-step [stepControl]="step1Group">
                      <ng-template matStepLabel>Locations & Images</ng-template>

                      <div class="col-9" style="margin: auto">
                        <div class="newForm">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Description *
                            <span matTooltip="Info about the action" style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span></label>
                          <div class="description">
                            <textarea class="textarea" [ngStyle]="{
                                'margin-bottom':
                                  addEquipmentStandardForm.get('description')
                                    ?.touched &&
                                  addEquipmentStandardForm
                                    .get('description')
                                    ?.hasError('required')
                                    ? '0px'
                                    : '20px',
                              }" matInput placeholder="Enter Description" name="description"
                              formControlName="description" required (paste)="onPasteCleanup('description')"></textarea>

                            <mat-error *ngIf="
                                addEquipmentStandardForm.get('description')
                                  .touched &&
                                addEquipmentStandardForm
                                  .get('description')
                                  .hasError('required')
                              ">
                              Description is required
                            </mat-error>
                          </div>

                          <!-- <mat-form-field>
                          
                        </mat-form-field> -->
                        </div>

                        <div [ngStyle]="{
                            'margin-bottom':
                              addEquipmentStandardForm.get('locationTypeId')
                                ?.touched &&
                              addEquipmentStandardForm
                                .get('locationTypeId')
                                ?.hasError('required')
                                ? '45px'
                                : '75px',
                          }">
                          <div style="
                              display: flex;
                              justify-content: space-between;
                            ">
                            <label for="operationsCategory" style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Location*
                              <span matTooltip="Info about the action" style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                            <button *ngIf="selectedLocations.length > 1" style="
                                background: transparent;
                                border: none;
                                background-color: white;
                              " (click)="clearAllSelected()">
                              clear all
                            </button>
                          </div>

                          <div style="max-height: 550px" class="multiLocations">
                            <ng-multiselect-dropdown [ngClass]="{
                                'invalid-border':
                                  step1Group.get('locationTypeId')?.invalid &&
                                  step1Group.get('locationTypeId')?.touched,
                              }" #locationDropdown class="dropdown-list" [placeholder]=""
                              [(ngModel)]="selectedLocations" [settings]="dropdownSettings"
                              [data]="LocationsdropdownList" (onSelect)="onItemSelect($event)"
                              (onDeSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)"
                              [ngModelOptions]="{ standalone: true }" (onDropDownOpen)="onDropdownOpen()">
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
                        <div>
                          <mat-error *ngIf="
                              addEquipmentStandardForm.get('locationTypeId')
                                .touched &&
                              addEquipmentStandardForm
                                .get('locationTypeId')
                                .hasError('required')
                            " style="font-size: x-small; margin-bottom: 20px">
                            Location is required
                          </mat-error>
                        </div>

                        <div *ngIf="showSublocationField()" [ngStyle]="{
                            'margin-bottom':
                              addEquipmentStandardForm.get('subLocationTypeId')
                                ?.touched &&
                              addEquipmentStandardForm
                                .get('subLocationTypeId')
                                ?.hasError('required')
                                ? '45px'
                                : '75px',
                          }">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Sub-Location*
                            <span matTooltip="Info about the action" style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span></label>
                          <div class="category-dropdown-wrapper">
                            <ng-multiselect-dropdown [ngClass]="{
                                'invalid-border':
                                  step1Group.get('subLocationTypeId')
                                    ?.invalid &&
                                  step1Group.get('subLocationTypeId')?.touched,
                              }" class="dropdown-list" [(ngModel)]="subLocationselected" [placeholder]=""
                              [settings]="equipmentdropdownSettings" [data]="sublocationDropdownList"
                              (onSelect)="onSubLocationSelect($event)"
                              (onDeSelect)="onSubLocationDeSelect($event)"
                              (onSelectAll)="onSelectAll($event)"
                              [ngModelOptions]="{ standalone: true }">
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
                        <div style="font-size: x-small; margin-bottom: 20px">
                          <mat-error *ngIf="
                              addEquipmentStandardForm.get('subLocationTypeId')
                                .touched &&
                              addEquipmentStandardForm
                                .get('subLocationTypeId')
                                .hasError('required')
                            ">
                            Sub-Location is required
                          </mat-error>
                        </div>

                        <div>
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Equipment Image*
                            <span matTooltip="Info about the action" style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span></label>
                          <div class="imageBox" [ngClass]="{
                              'invalid-border':
                                step1Group.get('image')?.invalid &&
                                step1Group.get('image')?.touched,
                            }">
                            <div>
                              <div class="row attachements" (click)="equipmentImage.click()">
                                <div style="
                                    margin: auto;
                                    text-align: center;
                                    padding: 10px;
                                  " *ngIf="
                                    !equipmentStandard.imageAttachment?.fileName
                                  ">
                                  <p style="
                                      color: #3f51b5;
                                      font-size: 14px;
                                      margin: 0;
                                    ">
                                    Choose Image
                                  </p>
                                  <p style="
                                      margin: 0;
                                      font-size: 12px;
                                      color: #696f77;
                                    ">
                                    *Only JPEG, PNG, & BMP Files Allowed
                                  </p>
                                </div>
                                <div class="uploaded-file" *ngIf="
                                    equipmentStandard.imageAttachment?.fileName
                                  " style="
                                    text-align: center;
                                    margin: auto;
                                    padding: 10px;
                                    display: flex;
                                  ">
                                  <div style="position: relative">
                                    <div style="
                                        border: 2px solid white;
                                        margin-left: 10px;
                                        height: 100px;
                                        width: 100px;

                                        border-radius: 6px;
                                      ">
                                      <img [src]="
                                          equipmentStandard.imageAttachmentContentAsBase64 ||
                                          equipmentStandard.imageAttachment?.image ||
                                          (equipmentStandard.imageAttachment?.attachmentContent
                                            ? (equipmentStandard.imageAttachment?.mime || 'data:image/png;base64,') + equipmentStandard.imageAttachment?.attachmentContent
                                            : '')
                                        " style="
                                          width: 100%;
                                          height: 100%;

                                          border-radius: 4px;
                                        " />
                                    </div>
                                    <div style="
                                        top: 0;
                                        position: absolute;
                                        right: 0;
                                        padding: 4px;
                                      ">
                                      <span *ngIf="
                                          equipmentStandard.imageAttachment
                                            ?.fileName
                                        ">
                                        <a href="javascript:void(0);" (click)="onRemoveImage()">
                                          <i class="material-icons delete-icon">
                                            cancel
                                          </i>
                                        </a>
                                      </span>
                                    </div>
                                    <!-- <span class="file-name">
                                    <a
                                      href="javascript:void(0);"
                                      (click)="
                                        onDownloadSelectedImage(
                                          equipmentStandard?.imageAttachment?.id
                                        )
                                      "
                                      >{{
                                        equipmentStandard.imageAttachment
                                          ?.fileName
                                      }}</a
                                    >
                                  </span> -->
                                    <!-- <span
                                    *ngIf="
                                      equipmentStandard.imageAttachment
                                        ?.fileName
                                    "
                                  >
                                    <a
                                      href="javascript:void(0);"
                                      (click)="onRemoveImage()"
                                    >
                                      <i class="material-icons delete-icon">
                                        cancel
                                      </i>
                                    </a>
                                  </span> -->
                                  </div>
                                </div>
                                <!-- <mat-label
                                  *ngIf="
                                    equipmentStandard.imageAttachment
                                      ?.fileName && isEditMode
                                  "
                                  >Image File</mat-label
                                > -->
                                <!-- <div class="uploaded-file">
                                  <span class="file-name">
                                    <a
                                      href="javascript:void(0);"
                                      (click)="
                                        onDownloadSelectedImage(
                                          equipmentStandard?.imageAttachment?.id
                                        )
                                      "
                                      >{{
                                        equipmentStandard.imageAttachment
                                          ?.fileName
                                      }}</a
                                    >
                                  </span>
                                  <span
                                    *ngIf="
                                      equipmentStandard.imageAttachment
                                        ?.fileName
                                    "
                                  >
                                    <a
                                      href="javascript:void(0);"
                                      (click)="onRemoveImage()"
                                    >
                                      <i class="material-icons delete-icon">
                                        cancel
                                      </i>
                                    </a>
                                  </span>
                                </div> -->
                                <input hidden type="file" (change)="onSelectImage($event)" #equipmentImage />
                              </div>
                            </div>
                          </div>
                          <div style="margin-top: -5px">
                            <mat-error class="mat-error-left-label" *ngIf="invalidImage">
                              Invalid file type.
                            </mat-error>
                            <mat-error class="mat-error-left-label" *ngIf="invalidImageRes">
                              Invalid image resolution.
                            </mat-error>
                            <mat-error style="font-size: x-small" *ngIf="
                                addEquipmentStandardForm.get('image').touched &&
                                addEquipmentStandardForm.get('image').invalid
                              ">
                              Equipment image is required
                            </mat-error>
                          </div>
                        </div>

                        <div style="margin-top: 40px">
                          <button matButton matStepperPrevious (click)="previousStep()" style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;
                              margin-right: 10px;
                              background-color: #ffffff;
                            ">
                            <img src="/assets/images/leftarrow.svg" alt="arrow" style="margin-right: 5px" />Back
                          </button>
                          <button (click)="nextStep()" matButton matStepperNext style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;

                              background-color: #ffffff;
                            ">
                            Next<img src="/assets/images/rightarrow.svg" alt="arrow" style="margin-left: 5px" />
                          </button>
                        </div>
                      </div>
                    </mat-step>

                    <mat-step [stepControl]="step2Group">
                      <div style="margin: auto" class="col-9">
                        <div style="margin-bottom: 30px">
                          <label for="operationsCategory" style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            ">Details*
                            <span matTooltip="Info about the action" style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "></span></label>
                          <quill-editor [ngClass]="{
                              'invalid-note':
                                step2Group.get('note')?.invalid &&
                                step2Group.get('note')?.touched,
                            }" name="note" formControlName="note" class="quill-editor-css"
                            (onEditorCreated)="onEditorCreated($event)">
                          </quill-editor>
                          <mat-error *ngIf="
                              addEquipmentStandardForm.get('note').touched &&
                              addEquipmentStandardForm
                                .get('note')
                                .hasError('required')
                            " style="font-size: x-small">
                            Details required
                          </mat-error>
                        </div>
                        <div style="margin-bottom: 30px">
                          <div>
                            <label for="operationsCategory" style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              ">Resources and Supportive Information
                              <span matTooltip="Info about the action" style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "></span></label>
                          </div>
                          <div formArrayName="resourceLinks1">
                            <div *ngFor="
                                let link of resourceLinks1.controls;
                                let i = index
                              " [formGroupName]="i" class="resourceBlock" [ngStyle]="{
                                'margin-bottom':
                                  addEquipmentStandardForm.get(
                                    'linksFieldValid'
                                  )?.touched ||
                                  addEquipmentStandardForm.get(
                                    'linksFieldValid'
                                  )?.invalid
                                    ? '20px'
                                    : '20px',
                              }">
                              <div style="position: relative; flex: 1" class="resourceLinkInValid" [ngClass]="{
                                  invalidborder:
                                    link.get('url')?.value == '' &&
                                    link.get('title')?.value,
                                }">
                                <input (paste)="onPasteLink($event, link)" type="url" formControlName="url"
                                  placeholder="Paste Link here..." (keydown)="disableTyping($event)"
                                  class="resource-input" />

                                <img *ngIf="link.get('url')?.value === ''" alt="mail" (click)="pasteLink(link)"
                                  src="/assets/images/Group (1).svg" style="
                                    position: absolute;
                                    right: 10px;
                                    top: 50%;
                                    transform: translateY(-50%);
                                    width: 18px;
                                    height: 18px;
                                    cursor: pointer;
                                  " />
                                <svg (click)="openLink(link.get('url')?.value)" *ngIf="link.get('url')?.value !== ''"
                                  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                  class="bi bi-box-arrow-up-right link-svg" viewBox="0 0 16 16">
                                  <path fill-rule="evenodd"
                                    d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                  <path fill-rule="evenodd"
                                    d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                </svg>
                                <div style="position: absolute; margin-top: -5px">
                                  <mat-error *ngIf="
                                      link.get('title')?.value &&
                                      link.get('url')?.value === ''
                                    " style="font-size: x-small">
                                    Url is required, if title is provided.
                                  </mat-error>
                                </div>
                                <!-- <img
                               class="nextWindow"
                               *ngIf="link.url != '' "
                                alt="mail"
                                (click)="pasteLink(link)"
                                src="/assets/images/Right Link (1).svg"
                                style="
                                  position: absolute;
                                  right: 10px;
                                  top: 50%;
                                  transform: translateY(-50%);
                                  width: 25px;
                                  height: 25px;
                                  cursor: pointer;
                                "
                              /> -->
                              </div>

                              <div style="position: relative; flex: 2" class="resourceTitleInValid" [ngClass]="{
                                  invalidborder:
                                    link.get('title')?.value == '' &&
                                    link.get('url')?.value,
                                }">
                                <input (input)="onEnterResourceTitle(link)" type="text" formControlName="title"
                                  placeholder="Enter Title" class="resource-input resource-description" />
                                <img (click)="removeLink(i)" alt="link" src="/assets/images/Right Link.svg" style="
                                    position: absolute;
                                    right: 10px;
                                    top: 50%;
                                    transform: translateY(-50%);
                                    width: 30px;
                                    height: 30px;
                                    cursor: pointer;
                                  " />
                                <div style="position: absolute; margin-top: -5px">
                                  <mat-error *ngIf="
                                      link.get('url')?.value &&
                                      link.get('title')?.value === ''
                                    " style="font-size: x-small">
                                    Title is required, if url is provided.
                                  </mat-error>
                                </div>
                              </div>
                            </div>
                          </div>

                          <button style="
                              border: 1px solid #ced2ed;
                              padding: 6px 10px 6px 10px;
                              background-color: #f1f3fb;
                              color: #5a69bf;
                              border-radius: 6px;
                              font-weight: 500;
                              margin-bottom: 10px;
                            " type="button" class="add-link-btn" (click)="addLinks()">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2">
                              <line x1="12" y1="5" x2="12" y2="19"></line>
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg>
                            Add Another Link
                          </button>
                        </div>

                        <div style="margin-top: 40px">
                          <button matButton matStepperPrevious (click)="previousStep()" style="
                              width: 100px;
                              height: 39px;
                              color: #4d5258;
                              font-weight: 500;
                              border-radius: 5px;
                              border: 1px solid #c1c6cd;
                              margin-right: 10px;
                              background-color: #ffffff;
                            ">
                            <img src="/assets/images/leftarrow.svg" alt="arrow" style="margin-right: 5px" />Back
                          </button>
                          <button disabled (click)="nextStep()" matButton matStepperNext style="
                              width: 100px;
                              height: 39px;

                              font-weight: 500;
                              border-radius: 5px;
                              color: #d2d3d5;
                              border: 1px solid #e0e2e6;

                              background-color: #ffffff;
                            ">
                            Next<img src="/assets/images/arrow-right 1.svg" alt="arrow" style="margin-left: 5px" />
                          </button>

                          <button [disabled]="checkFormValidity()" (click)="nextStep()" matButton matStepperNext
                            [ngStyle]="{
                              color: checkFormValidity() ? '#888888' : 'black',
                              cursor: checkFormValidity()
                                ? 'not-allowed'
                                : 'pointer',
                              backgroundColor: checkFormValidity()
                                ? '#e0e0e0'
                                : '#ffbc0f',
                              borderColor: '#c1c6cd',
                              fontWeight: 'bold',
                              float: 'right',
                              padding: '4px 16px',
                              borderRadius: '5px',
                              border: 'none',
                              width: '100px',
                              height: '39px',
                            }">
                            Review
                          </button>
                        </div>
                      </div>
                    </mat-step>

                    <mat-step>
                      <ng-template matStepLabel>Preview</ng-template>
                      <div style="padding: 12px">
                        <div class="review-page-container">
                          <!-- <div class="header"> -->
                          <!-- <div class="stamp">{{ data.stampText }}</div> -->
                          <!-- </div> -->

                          <div style="
                              display: flex;
                              justify-content: space-between;
                            ">
                            <div style="
                                width: 431px;
                                /* height: 463px; */
                                border: 1px solid #ffebb7;
                                padding: 16px 24px 24px 24px;
                                border-radius: 8px;
                                align-content: center;
                                gap: 8px;
                              ">
                              <div style="
                                  width: 383px;
                                  height: 32px;
                                  /* border: 1px solid black; */
                                  margin-bottom: 10px;
                                ">
                                <img *ngIf="lastPageSupplier?.attachmentContent" [src]="
                                    'data:image/jpeg;base64,' +
                                    lastPageSupplier.attachmentContent
                                  " style="
                                    /* width: 100%; */
                                    height: 100%;
                                    object-fit: contain;
                                    border-radius: 4px;
                                  " />
                              </div>
                              <div style="
                                  width: 383px;
                                  height: 383px;

                                  margin: auto;
                                ">
                                <img [src]="
                                    equipmentStandard.imageAttachmentContentAsBase64 ||
                                    equipmentStandard.imageAttachment?.image ||
                                    (equipmentStandard.imageAttachment?.attachmentContent
                                      ? (equipmentStandard.imageAttachment?.mime || 'data:image/png;base64,') + equipmentStandard.imageAttachment?.attachmentContent
                                      : '')
                                  " style="
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                    border-radius: 4px;
                                  " />
                              </div>
                            </div>
                            <div class="info-main" style="width: 59%">
                              <div>
                                <h1 class="lastpage-title" style="padding: 10px">
                                  {{
                                  addEquipmentStandardForm.get("title")?.value
                                  }}
                                </h1>
                              </div>
                              <div class="info-section">
                                <!-- <div class="divider"></div> -->

                                <div class="info-column right-column">
                                  <!-- <div class="info-row">
                                    <span class="reviewPage-icon date"></span>
                                    <span class="label">Approved For Use</span>
                                    <span class="value">{{
                                      addEquipmentStandardForm.get(
                                        "effectiveFrom"
                                      )?.value | date : "dd, MMM yyyy"
                                    }}</span>
                                  </div> -->

                                  <!-- <div class="info-row">
                                    <span class="reviewPage-icon date2"></span>
                                    <span class="label">Obsolete Date</span>
                                    <span class="value">{{
                                      addEquipmentStandardForm.get(
                                        "obsoleteDate"
                                      )?.value | date : "dd, MMM yyyy"
                                    }}</span>
                                  </div> -->

                                  <div class="info-row">
                                    <span class="reviewPage-icon standardType"></span>
                                    <span class="label">Equipment Type</span>
                                    <span class="value">{{
                                      lastPageEquipmentType
                                      }}</span>
                                  </div>
                                  <div class="info-row">
                                    <span class="reviewPage-icon category"></span>
                                    <span class="label">Supplier</span>
                                    <span class="value">{{
                                      lastPageSupplier
                                      }}</span>
                                  </div>

                                  <div class="info-row">
                                    <span class="reviewPage-icon location"></span>
                                    <span class="label">Model</span>
                                    <span class="value">{{
                                      addEquipmentStandardForm.get("model")
                                      ?.value
                                      }}</span>
                                  </div>
                                  <div class="info-row">
                                    <span class="reviewPage-icon location"></span>
                                    <span class="label">Location</span>
                                    <span class="value">{{
                                      selectedLocationNames
                                      }}</span>
                                  </div>

                                  <div class="info-row">
                                    <span class="reviewPage-icon Sublocation"></span>
                                    <span class="label">Sub Location</span>
                                    <span class="value">{{
                                      subLocationselected != ""
                                      ? lastPageSublocation
                                      : "--"
                                      }}</span>
                                  </div>

                                  <div class="info-row">
                                    <span class="reviewPage-icon createdOn"></span>
                                    <span class="label">Created On</span>
                                    <span class="value">{{
                                      createdOn | date: "dd, MMM yyyy"
                                      }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="description-section">
                            <div style="
                                display: flex;
                                align-items: center;
                                align-content: center;
                              ">
                              <h2 class="section-title">Description</h2>
                              <button class="copyIcon">
                                <img (click)="
                                    copyText(
                                      addEquipmentStandardForm.get(
                                        'description'
                                      ).value
                                    );
                                    $event.stopPropagation()
                                  " src="../../assets/images/copy text.svg" alt="" />
                              </button>
                            </div>
                            <p class="description-text">
                              {{
                              addEquipmentStandardForm.get("description")
                              ?.value
                              }}
                            </p>
                          </div>

                          <div class="details-section" style="margin-top: 20px">
                            <div class="details-header" (click)="toggleDetails()">
                              <div class="details-title-wrapper">
                                <div>
                                  <span class="toggle-icon">
                                    <img *ngIf="!detailsExpanded" src="../../assets/images/s-add 1.svg" alt="Expand"
                                      style="margin-bottom: 3px" />
                                    <img *ngIf="detailsExpanded" src="../../assets/images/cross (2).svg" alt="Collapse"
                                      style="margin-bottom: 3px" /></span>
                                  <!-- <span class="details-icon">☑</span> -->
                                  <span class="details-title"> Details </span>
                                </div>
                                <div *ngIf="detailsExpanded">
                                  <img (click)="
                                      copyText(
                                        addEquipmentStandardForm.get('note')
                                          .value
                                      );
                                      $event.stopPropagation()
                                    " src="../../assets/images/copy text.svg" alt="" />
                                </div>
                              </div>
                            </div>

                            <div class="details-content" [class.expanded]="detailsExpanded">
                              <div [innerHTML]="getDetails()" class="detail-section"></div>
                            </div>
                          </div>

                          <div class="bottom-sections">
                            <div class="resources-section" *ngIf="hasResourceUrls">
                              <div class="section-header">
                                <h2 class="section-heading">
                                  Resources and Supporting Information
                                </h2>
                                <span class="info-icon-circle">?</span>
                              </div>
                              <div class="links-list" formArrayName="resourceLinks1">
                                <a *ngFor="
                                    let resource of resourceLinks1.controls;
                                    let i = index
                                  " [formGroupName]="i" [href]="resource.get('url')?.value" class="resource-link">
                                  {{ resource.get("title")?.value }}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style="margin-top: 40px; padding: 0 14px 0 14px">
                        <button [disabled]="checkFormValidity()" matButton (click)="previousStep()" matStepperPrevious
                          style="
                            width: 100px;
                            height: 39px;
                            color: #4d5258;
                            font-weight: 500;
                            border-radius: 5px;
                            border: 1px solid #c1c6cd;
                            margin-right: 10px;
                            background-color: #ffffff;
                          ">
                          <img src="/assets/images/leftarrow.svg" alt="arrow" style="margin-right: 5px" />Back
                        </button>
                        <button disabled matButton matStepperNext style="
                            width: 100px;
                            height: 39px;
                            color: #d2d3d5;
                            border: 1px solid #e0e2e6;
                            font-weight: 500;
                            border-radius: 5px;
                            background-color: #ffffff;
                          ">
                          Next<img src="/assets/images/arrow-right 1.svg" alt="arrow" style="margin-left: 5px" />
                        </button>

                        <button [disabled]="checkFormValidity()" (click)="save()" matButton [ngStyle]="{
                            color: checkFormValidity() ? '#888888' : 'black',
                            cursor: checkFormValidity()
                              ? 'not-allowed'
                              : 'pointer',
                            backgroundColor: checkFormValidity()
                              ? '#e0e0e0'
                              : '#ffbc0f',
                            borderColor: '#c1c6cd',
                            fontWeight: 'bold',
                            float: 'right',

                            borderRadius: '5px',
                            border: 'none',
                            width: '100px',
                            height: '39px',
                          }">
                          Submit
                        </button>
                      </div>
                    </mat-step>
                  </mat-stepper>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="mcd-upload-images">
          <div class="row attachements">
            <div class="col">
              <a href="javascript:void(0);" (click)="equipmentImage.click()">
                <span>
                  <img
                    alt="Upload Image"
                    src="/assets/images/attachement.svg"
                  />
                </span>
                Upload Image (JPEG, PNG, BMP)
              </a>
              <mat-label
                *ngIf="
                  equipmentStandard.imageAttachment?.fileName && isEditMode
                "
                >Image File</mat-label
              >
              <div class="uploaded-file">
                <span class="file-name">
                  <a
                    href="javascript:void(0);"
                    (click)="
                      onDownloadSelectedImage(
                        equipmentStandard?.imageAttachment?.id
                      )
                    "
                    >{{ equipmentStandard.imageAttachment?.fileName }}</a
                  >
                </span>
                <span *ngIf="equipmentStandard.imageAttachment?.fileName">
                  <a href="javascript:void(0);" (click)="onRemoveImage()">
                    <i class="material-icons delete-icon"> cancel </i>
                  </a>
                </span>
              </div>
              <input
                hidden
                type="file"
                (change)="onSelectImage($event)"
                #equipmentImage
              />
              <mat-error class="mat-error-left-label" *ngIf="invalidImage">
                Invalid file type.
              </mat-error>
              <mat-error class="mat-error-left-label" *ngIf="invalidImageRes">
                Invalid image resolution.
              </mat-error>
            </div>

            <div class="col text-right">
              <a href="javascript:void(0);" (click)="equipmentDoc.click()">
                <span>
                  <img
                    alt="Upload Image"
                    src="/assets/images/attachement.svg"
                  />
                </span>
                Attach File (doc, docx, pdf)
              </a>
              <mat-label
                *ngIf="
                  equipmentStandard.equipmentAttachment?.fileName && isEditMode
                "
                >Attachment</mat-label
              >
              <div class="uploaded-file qr-code">
                <span class="file-name">
                  <a
                    href="javascript:void(0);"
                    (click)="
                      onDownloadSelectedAttachment(
                        equipmentStandard.equipmentAttachment
                      )
                    "
                    >{{ equipmentStandard.equipmentAttachment?.fileName }}</a
                  >
                </span>
                <span *ngIf="equipmentStandard.equipmentAttachment?.fileName">
                  <a href="javascript:void(0);" (click)="onRemoveAttachment()">
                    <i class="material-icons delete-icon"> cancel </i>
                  </a>
                </span>
              </div>
              <input
                hidden
                type="file"
                (change)="onSelectAttachment($event)"
                #equipmentDoc
              />
              <mat-error
                class="mat-error-right-label"
                *ngIf="invalidAttachment"
              >
                Invalid file type.
              </mat-error>
            </div>
          </div>
        </div> -->
      </form>
    </mat-card-content>
    <!-- <mat-card-footer class="mcd-card-footer">
      <button
        class="mcd-btn mcd-btn-primary"
        *ngIf="!equipmentStandard.id"
        mat-raised-button
        (click)="resetForm()"
      >
        Reset
      </button>
      <button
        class="mcd-btn mcd-btn-primary"
        *ngIf="equipmentStandard.id > 0"
        mat-raised-button
        (click)="onBackClickorEditRedirect()"
      >
        Back
      </button>
      <button
        class="mcd-btn mcd-btn-secondary"
        mat-raised-button
        [disabled]="checkFormValidity()"
        (click)="save()"
        *ngIf="!isEditMode"
      >
        Add
      </button>
      <button
        class="mcd-btn mcd-btn-secondary"
        mat-raised-button
        [disabled]="checkFormValidity()"
        (click)="save()"
        *ngIf="isEditMode"
      >
        Update
      </button>
    </mat-card-footer> -->
  </div>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>